import React from 'react';
import { FeedEntity } from './FeedEntity';

type FeedContextType = [FeedEntity[], React.Dispatch<React.SetStateAction<FeedEntity[]>>];

export const FeedContext = React.createContext<FeedContextType>(
    [[], () => {}]
);
